"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var budget_1 = tslib_1.__importDefault(require("./budget"));
var account_1 = tslib_1.__importDefault(require("./account"));
var series_1 = tslib_1.__importDefault(require("./series"));
var location_1 = tslib_1.__importDefault(require("./location"));
var set_1 = tslib_1.__importDefault(require("./set"));
var VarianceResource = /** @class */ (function (_super) {
    tslib_1.__extends(VarianceResource, _super);
    function VarianceResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VarianceResource.endpoint = '/variances';
    VarianceResource.MODEL_NAME = 'budgetline';
    VarianceResource.related = {
        account: account_1.default,
        budget: budget_1.default,
        series: series_1.default,
        location: location_1.default,
        set: set_1.default,
    };
    return VarianceResource;
}(base_1.default));
exports.default = VarianceResource;
//# sourceMappingURL=variance.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/system/variance.js
// module id = YIVJ
// module chunks = 0